import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { deserializeControlValue, serializeControlValue } from "../../lib/control.js";
import { computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createVNode, mergeProps, openBlock, resolveDirective, resolveDynamicComponent, toDisplayString, unref, withCtx, withDirectives } from "vue";
import DtIconLock from "@dialpad/dialtone-icons/vue3/lock";
import { DtBadge } from "@dialpad/dialtone-vue";
//#region src/components/option_bar/option_bar_control.vue
var _hoisted_1 = {
	class: "d-tt-capitalize",
	"data-qa": "dtc-option-bar-control-label"
};
var _hoisted_2 = {
	key: 1,
	class: "d-pl2 d-ps-relative d-b2"
};
var _hoisted_3 = {
	key: 2,
	class: "d-pl2 d-ps-relative d-b2"
};
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcOptionBarControl" }, {
	props: {
		controlData: {
			type: Object,
			required: true
		},
		validControls: {
			type: Array,
			required: true
		},
		value: {
			type: void 0,
			required: true
		},
		label: {
			type: String,
			required: true
		},
		description: {
			type: String,
			default: void 0
		},
		vModel: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		locked: {
			type: Boolean,
			default: false
		},
		args: {
			type: Object,
			default: () => {}
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const controlValue = computed(() => {
			return props.controlData.serialize ? serializeControlValue(props.value) : props.value;
		});
		const controlLabel = computed(() => props.label.replaceAll("-", " "));
		const controlComponent = computed(() => {
			return props.controlData.component;
		});
		/**
		* Args that are conditionally passed to the
		* underlying control props if the prop is present on the control.
		*
		* @type {ComputedRef<object>}
		*/
		const controlArgs = computed(() => {
			return {
				value: controlValue.value,
				disabled: props.locked,
				tags: props.tags,
				...props.args
			};
		});
		/**
		* Object containing only the args that are
		* present on the control component props.
		*
		* @type {ComputedRef<object>}
		*/
		const controlBindings = computed(() => {
			const component = controlComponent.value;
			if (!component.props) return null;
			return Object.fromEntries(Object.entries(controlArgs.value).filter(([arg]) => {
				return Object.keys(component.props).includes(arg);
			}));
		});
		/**
		* Emits an update to the member value.
		* The value is deserialized if needed.
		*
		* @param e - The updated member value
		*/
		function updateValue(e) {
			emit(VALUE_UPDATE_EVENT, props.controlData.serialize ? deserializeControlValue(e) : e);
		}
		return (_ctx, _cache) => {
			const _directive_dt_tooltip = resolveDirective("dt-tooltip");
			return openBlock(), createElementBlock("div", null, [(openBlock(), createBlock(resolveDynamicComponent(controlComponent.value), mergeProps(controlBindings.value, { "onUpdate:value": updateValue }), {
				default: withCtx(() => [withDirectives((openBlock(), createElementBlock("span", null, [
					createElementVNode("span", _hoisted_1, toDisplayString(controlLabel.value), 1),
					__props.locked ? (openBlock(), createBlock(unref(DtIconLock), {
						key: 0,
						class: "d-pr4 d-fs10 d-ps-relative d-t1"
					})) : createCommentVNode("", true),
					__props.required ? (openBlock(), createElementBlock("span", _hoisted_2, [createVNode(unref(DtBadge), {
						text: "required",
						color: "black-700"
					})])) : createCommentVNode("", true),
					__props.vModel ? (openBlock(), createElementBlock("span", _hoisted_3, [createVNode(unref(DtBadge), {
						text: "v-model",
						color: "black-700"
					})])) : createCommentVNode("", true)
				])), [[_directive_dt_tooltip, __props.description]])]),
				_: 1
			}, 16))]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=option_bar_control.vue.js.map